export default "__VITE_ASSET__crRf44Vu__"